import { render, staticRenderFns } from "./privateEvent.html?vue&type=template&id=149a8853&external"
import script from "./privateEvent.vue?vue&type=script&lang=js"
export * from "./privateEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports